import * as React from "react";
import { Units } from "./index";
import { UnitPopup } from "./unitPopup";

export interface UnitItem {
    position: number;
    id: number | null;
    level: number;
    amount: number;
}

export interface UnitProps {
    i: number;
    j: number;
    position: number;
    blocked: boolean;
    units: Units;
    currentUnit?: {
        id: number | null;
        level: number;
        amount: number;
    };
    unit?: UnitItem;

    onSave(unit: UnitItem);

    onRemove(unit: UnitItem);
}

export class Unit extends React.Component<UnitProps, UnitItem> {
    constructor(props: UnitProps) {
        super(props);

        this.state = {
            position: this.props.position,
            id: this.props.unit?.id || null,
            level: this.props.unit?.level || 1,
            amount: this.props.unit?.amount || 1
        };
    }

    save = (unit) => {
        this.setState({
            id: unit.id,
            level: unit.level,
            amount: unit.amount
        }, () => {
            this.props.onSave(this.state);
        });
    };

    remove = () => {
        this.setState({
            id: null,
        }, () => {
            this.props.onRemove(this.state);
        });
    };

    render() {
        if (!this.state.id && this.props.blocked) {
            return <td className={"cell-" + this.props.position + " unavailable-cell"}
                       key={`row-${this.props.i}-col${this.props.j}`}/>;
        }

        let className = " available-cell";
        if (this.state.id && this.state.amount) {
            className += " active-cell";
        }

        return <td className={"cell-" + this.props.position + className} key={`row-${this.props.i}-col${this.props.j}`}>
            <UnitPopup unit={this.state} units={this.props.units} currentUnit={this.props.currentUnit}
                       remove={this.remove} save={this.save}/>
        </td>;
    }
}
